/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

export const getUIColors = contrasts => ({
  surfacePagePrimary: contrasts === null || contrasts === void 0 ? void 0 : contrasts.white1010,
  surfacePageSecondary: contrasts === null || contrasts === void 0 ? void 0 : contrasts.grey1111,
  surfaceCardPrimary: contrasts === null || contrasts === void 0 ? void 0 : contrasts.white1010,
  surfaceCardSecondary: contrasts === null || contrasts === void 0 ? void 0 : contrasts.grey1111,
  surfaceDark: contrasts === null || contrasts === void 0 ? void 0 : contrasts.grey100100,
  textTitle: contrasts === null || contrasts === void 0 ? void 0 : contrasts.grey125125,
  textDescription: contrasts === null || contrasts === void 0 ? void 0 : contrasts.grey125125,
  textBody: contrasts === null || contrasts === void 0 ? void 0 : contrasts.grey125125,
  textTimestamp: contrasts === null || contrasts === void 0 ? void 0 : contrasts.grey5782,
  textAuthor: contrasts === null || contrasts === void 0 ? void 0 : contrasts.grey5782,
  textDatapoint: contrasts === null || contrasts === void 0 ? void 0 : contrasts.grey5782,
  textLink: contrasts === null || contrasts === void 0 ? void 0 : contrasts.blue5782,
  textPlaceholder: contrasts === null || contrasts === void 0 ? void 0 : contrasts.grey2424,
  textSuccess: contrasts === null || contrasts === void 0 ? void 0 : contrasts.green5782,
  textWarning: contrasts === null || contrasts === void 0 ? void 0 : contrasts.orange5782,
  textError: contrasts === null || contrasts === void 0 ? void 0 : contrasts.red5782,
  lineStroke: contrasts === null || contrasts === void 0 ? void 0 : contrasts.grey1424,
  lineDivider: contrasts === null || contrasts === void 0 ? void 0 : contrasts.grey1214,
  surfaceOverlayGrey: contrasts === null || contrasts === void 0 ? void 0 : contrasts.grey100100op75,
  surfaceOverlayWhite: contrasts === null || contrasts === void 0 ? void 0 : contrasts.white1010op75,
  surfaceAttention: contrasts === null || contrasts === void 0 ? void 0 : contrasts.blue4570,
  surfaceSuccess: contrasts === null || contrasts === void 0 ? void 0 : contrasts.green4570,
  surfaceWarning: contrasts === null || contrasts === void 0 ? void 0 : contrasts.orange4570,
  surfaceError: contrasts === null || contrasts === void 0 ? void 0 : contrasts.red4570,
  surfaceDivider: contrasts === null || contrasts === void 0 ? void 0 : contrasts.grey1214,
  textSurfaceColored: contrasts === null || contrasts === void 0 ? void 0 : contrasts.white1010,
  iconDefault: contrasts === null || contrasts === void 0 ? void 0 : contrasts.grey125125,
  iconSuccess: contrasts === null || contrasts === void 0 ? void 0 : contrasts.green4570,
  iconWarning: contrasts === null || contrasts === void 0 ? void 0 : contrasts.orange4570,
  iconError: contrasts === null || contrasts === void 0 ? void 0 : contrasts.red4570,
  iconSurfaceColored: contrasts === null || contrasts === void 0 ? void 0 : contrasts.white1010,
  lineConnector: contrasts === null || contrasts === void 0 ? void 0 : contrasts.grey1424
});
export default getUIColors;